/**
 * Determines if an error is a user wallet rejection error
 * 
 * @param {unknown} err - The error to check
 * @returns {boolean} True if the error is a user wallet rejection, false otherwise
 */
export const isUserWalletRejection = (err: unknown): boolean => {
  return err instanceof Error && err.message.toLowerCase().includes("user rejected");
}

export const isInsufficientManagerFunds = (err: unknown): boolean => {
  return err instanceof Error && err.message.toLowerCase().includes("insufficientmanagerfunds");
}
